module.exports = __webpack_public_path__ + "img/easi.c173908a.jpeg";